import { SearchInput } from '../../components/SearchInputForm';
import { jsx as _jsx } from "react/jsx-runtime";
const label = 'viewsManagement.addView.searchInput';
export const AddViewSearchInput = props => /*#__PURE__*/_jsx(SearchInput, {
  onChange: props.onChange,
  value: props.value,
  disabled: props.disabled,
  error: props.error,
  label: label,
  use: "on-dark",
  autoFocus: props.autoFocus
});